import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'grid',
      gridTemplateColumns: '220px 1fr',
      height: '100%',

      '& > form': {
        minHeight: 0,
      },
    },
  }),
)
